import { create } from 'zustand';
import { User } from '../services/authService';

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  setAuth: (user: User, token: string) => void;
  updateUser: (user: User) => void;
  logout: () => void;
  initAuth: () => void;
}

// Read from localStorage synchronously so state is ready before first render
const _token = localStorage.getItem('token');
const _userStr = localStorage.getItem('user');
let _initialUser: User | null = null;
let _initialToken: string | null = null;
if (_token && _userStr) {
  try {
    _initialUser = JSON.parse(_userStr);
    _initialToken = _token;
  } catch {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
}

export const useAuthStore = create<AuthState>((set) => ({
  user: _initialUser,
  token: _initialToken,
  isAuthenticated: !!_initialUser && !!_initialToken,

  setAuth: (user, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    set({ user, token, isAuthenticated: true });
  },

  updateUser: (user) => {
    localStorage.setItem('user', JSON.stringify(user));
    set({ user });
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    set({ user: null, token: null, isAuthenticated: false });
  },

  initAuth: () => {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');
    
    if (token && userStr) {
      try {
        const user = JSON.parse(userStr);
        set({ user, token, isAuthenticated: true });
      } catch (error) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
  },
}));
